import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiUniqueContactAsyncValidatorDirective } from './fi-unique-contact-async-validator.directive';
import { FiPatternAsyncValidatorDirective } from '@fi-shared/fi-directives/fi-custom-validators/fi-pattern-async-validator.directive';
import { EqualToValidatorDirective } from '@fi-shared/fi-directives/fi-custom-validators/equalto-validator.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [FiUniqueContactAsyncValidatorDirective, FiPatternAsyncValidatorDirective, EqualToValidatorDirective],
    exports: [FiUniqueContactAsyncValidatorDirective, FiPatternAsyncValidatorDirective, EqualToValidatorDirective],
})
export class FiCustomValidatorsModule {}
